import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@node_modules/@angular/router";
import { Observable, map } from "rxjs";
import { AppComponentBase } from "@shared/common/app-component-base";
import { ApplicationService } from "../application/application.service";
import { NpfService } from "./npf.service";

@Injectable()
export class NpfGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private npfService: NpfService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.npfService.getNpf(this.applicationService.caseId).pipe(map(() => true));
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.npfService.closeNpf();
        return true;
    }
}